module.exports = __webpack_public_path__ + "img/solution-preevision-function-icon-2.795d3f18.svg";